export default {
	"language.name": "繁體中文",
	"product.PleaseEnter": "請輸入產品名稱",
	"product.PleaseEnterTheProductSerialNumber": "請輸入產品序號",
	"product.PleaseEnterSubmodelNumber": "請輸入子型號",
	"product.PleaseenterTheSubmodelSerialNumber": "請輸入子型號序號",
	"product.PleaseSelectTheDeviceType": "請選擇設備類型",
	"product.PleaseSelectDevelopmentType": "請選擇研發類型",
	"product.management": "產品管理",
	"product.name": "產品名稱",
	"product.reset": "重置",
	"product.search": "搜尋",
	"product.ApplicationList": "應用列表",
	"product.newProduct": "新建產品",
	"product.editName": "編輯產品",
	"product.DetailSetting": "詳細設定",
	"product.delete": "刪除",
	"product.serialNumber": "產品序號",
	"product.deviceType": "設備類型",
	"product.RandDtype": "研發類型",
	"product.subType": "子型號",
	"product.updateTime": "更新時間",
	"product.operation": "操作",
	"product.deviceList": "設備清單(出貨日誌)",
	"product.parameterManagement": "參數管理",
	"product.updataManagement": "升級管理",
	"product.ParentDevice": "父設備",
	"product.AssociatedPowerStationState": "關聯電站狀態",
	"product.ImportDeviceList": "導入設備清單",
	"product.PlantDetails": "電站詳細",
	"product.parameterName": "參數名稱",
	"product.OwningPowerStation": "所屬電站",
	"product.ParameterClass": "參數類別",
	"product.ParameterSettingType": "參數設定類型",
	"product.ParameterOperationType": "參數操作類型",
	"product.ImportParameter": "導入參數",
	"product.OwningUpperLevelParameterCategory": "所屬上級參數分類",
	"product.WhetherYoSupportBatchRead": "是否支援批量讀",
	"product.value": "值",
	"product.scope": "範圍",
	"product.unit": "單位",
	"product.explain": "說明",
	"product.remark": "備註",
	"product.fileName": "文件名",
	"product.fileAddress": "文件地址",
	"product.versionNumber": "版本號",
	"product.ProductOfOwnership": "所屬產品",
	"product.ProductDetailsSettings": "陽台1.0 - 產品詳細設定",
	"product.QueryResultList": "查詢結果列表",
	"product.AddFirmware": "新增韌體",
	"product.NewParameter": "新增參數",
	"product.datalog": "采集器",
	"product.Inverter": "逆變器",
	"product.storage": "儲能",
	"product.battery": "電池",
	"product.socket": "插座",
	"product.DownloadTemplate": "下載模板",
	"product.nation": "國家",
	"product.agent": "代理商",
	"product.expirationDate": "保質期",
	"product.UpdateTime": "更新時間",
	"product.LastWeek": "最近一週",
	"product.LastMonth": "最近一個月",
	"product.LastThreeMonths": "最近三個月",
	"product.parameterType": "參數類型",
	"product.ProtocolAddress": "協議地址",
	"product.stepSize": "步長",
	"product.PleaseEnterAParameterName": "請輸入參數名稱",
	"product.parameterCoding": "參數編碼",
	"product.PleaseEnterTheParameterCode": "請輸入參數編碼",
	"product.ParameterDataType": "參數資料類型",
	"product.PleaseEnterTheAddressInTheParameterProtocol": "請輸入協議中的參數地址",
	"product.blockEncoding": "區塊編碼",
	"product.PleaseEnterABlockCode": "請輸入區塊編碼",
	"product.GroupName": "群組名稱",
	"product.PleaseEnterAGroupName": "請輸入群組名稱",
	"product.PleaseEnterTheUnit": "請輸入單位",
	"product.decimalPoint": "小數點",
	"product.PleaseEnterTheDecimalPoint": "請輸入小數點",
	"product.leastValue": "最小值",
	"product.maximumValue": "最大值",
	"product.PleaseEnterTheMaximumValue": "請輸入最大值",
	"product.PleaseEnterTheStepSize": "請輸入步長",
	"product.addEquipment": "新增設備",
	"product.equipment": "設備",
	"product.remove": "移除",
	"product.sort": "排序",
	"product.PleaseEnterTheOrder": "請輸入排序",
	"product.PleaseEnterTheParameterSettingType": "請輸入參數設定類型",
	"product.PleaseSelectAFolderPath": "請選擇文件夾路徑",
	"product.ReturnToSuperior": "返回上級",
	"product.PleaseEnterTheVersionNumber": "請輸入版本號",
	"product.firmwareSpecification": "韌體說明",
	"product.PleaseEnterFirmwareDescription": "請輸入韌體說明",
	"product.FileName": "文件名稱",
	"product.DeviceType": "設備類型",
	"product.FileAddress": "文件地址",
	"product.time": "時間",
	"sidebar.home": "數據概覽",
	"sidebar.endbenutzer": "用戶管理",
	"sidebar.plant": "場景管理",
	"sidebar.plant_plant": "電廠管理",
	"sidebar.device": "設備管理",
	"sidebar.datalog": "採集器列表",
	"sidebar.inverter": "逆變器列表",
	"sidebar.sotrage": "儲能列表",
	"sidebar.socket": "插座列表",
	"sidebar.battery": "電池列表",
	"sidebar.agent": "代理商管理",
	"sidebar.systematicSupply": "出貨日誌",
	"sidebar.firmware": "固件列表",
	"sidebar.firmware_up": "固件上傳",
	"sidebar.firmware_log": "升級記錄",
	"sidebar.system": "系統設置",
	"sidebar.system_datalog_log": "採集器日誌",
	"sidebar.system_log": "操作日誌",
	"sidebar.system_tongxun": "通訊日誌",
	"sidebar.system_app": "App 版本",
	"sidebar.personal": "用戶資訊",
	"sidebar.logout": "退出帳戶",
	"sidebar.organizationalManagement": "組織管理",
	"login.email": "郵箱",
	"login.password": "密碼",
	"login.remember": "記住郵箱和密碼",
	"login.rememberAccount": "記住帳號和密碼",
	"login.enteremail": "請輸入郵箱",
	"login.enterpassword": "請輸入密碼",
	"login.accountNumber": '帳號',
	"login.system": '海爾智慧能源管理系統',
	"login.read": '閱讀並同意',
	"login.userAgreement": '《用戶協議》',
	"login.privacyPolicy": '《隱私政策》',
	"login.retrievePassword": '找回密碼',
	"login.verCode": '驗證碼',
	"login.newPassword": '新密碼',
	"login.sendverCode": '發送驗證碼',
	"login.greenLife": "創新清潔能源 共建綠色生活",
	"login.welcome": "歡迎來到海爾能源雲",
	"login.sure": "確定",
	"home.echarts1.title": "註冊用戶",
	"home.echarts1.subhead": "今日新增/用戶總數",
	"home.echarts2.title": "登錄用戶",
	"home.echarts2.subhead": "今日登錄/用戶總數",
	"home.echarts3.title": "添加代理商",
	"home.echarts3.subhead": "今日登錄/代理商總數",
	"home.echarts4.title": "添加場景",
	"home.echarts4.subhead": "新增場景/場景總數",
	"home.echarts4.title_plant": "添加電站",
	"home.echarts4.subhead_plant": "新增電站/電站總數",
	"home.echarts5.title": "添加採集器",
	"home.echarts5.subhead": "新增採集器/採集器總數",
	"home.echarts6.title": "添加設備",
	"home.echarts6.subhead": "新增設備/設備總數",
	"End_user.input_email": "請輸入用戶郵箱",
	"End_user.btn_search": "搜索",
	"End_user.btn_add": "添加",
	"End_user.btn_delete": "刪除",
	"End_user.btn_binding": "綁定",
	"End_user.add_station": "新增場景",
	"End_user.lable_StationName": "場景名稱",
	"End_user.lable_StationType": "場景類型",
	"End_user.lable_PVCapacity": "太陽電池容量",
	"End_user.lable_InstalltionDate": "安裝日期",
	"End_user.lable_Country": "國家",
	"End_user.lable_City": "城市",
	"End_user.lable_Address": "地址",
	"End_user.lable_TimeZone": "時區",
	"End_user.lable_Energyprice": "能源單價",
	"End_user.lable_IncomeUnit": "收入單位",
	"End_user.input_StationName": "請輸入場景名稱",
	"End_user.input_StationType": "請選擇類型",
	"End_user.input_PVCapacity": "請輸入電池容量",
	"End_user.input_InstalltionDate": "請選擇安裝日期",
	"End_user.input_Country": "請選擇國家",
	"End_user.input_City": "請選擇城市",
	"End_user.input_Address": "請輸入地址",
	"End_user.input_TimeZone": "請選擇時區",
	"End_user.input_Energyprice": "請輸入單價",
	"End_user.input_IncomeUnit": "選擇收入單位",
	"End_user.max_20": "字元最大不能超過20個",
	"End_user.max_5": "字元最大不能超過5個",
	"End_user.max_8": "字元最大不能超過8個",
	"End_user.format": "請輸入正確的格式",
	"End_user.close": "關閉",
	"End_user.submit": "提交",
	"End_user.title_delete": "刪除？",
	"End_user.no": "否",
	"End_user.yes": "是",
	"End_user.Bingding_Agent": "綁定代理商",
	"End_user.Agent_Code": "代理商:",
	"End_user.please_select": "請選擇",
	"plant.input_email": "請輸入用戶郵箱",
	"plant.search": "搜索",
	"plant.edit": "編輯",
	"plant.delete": "刪除",
	"plant.edit_plant": "編輯場景",
	"plant.input_station": "請輸入場景名稱",
	"plant.lable_StationName": "場景名稱",
	"plant.lable_StationType": "場景類型",
	"plant.lable_PVCapacity": "太陽電池容量",
	"plant.lable_InstalltionDate": "安裝日期",
	"plant.lable_Country": "國家",
	"plant.lable_City": "城市",
	"plant.lable_Address": "地址",
	"plant.lable_TimeZone": "時區",
	"plant.lable_Energyprice": "能源單價",
	"plant.lable_IncomeUnit": "收入單位",
	"plant.input_StationName": "請輸入場景名稱",
	"plant.input_StationType": "請選擇類型",
	"plant.input_PVCapacity": "請輸入電池容量",
	"plant.input_InstalltionDate": "請選擇安裝日期",
	"plant.input_Country": "請選擇國家",
	"plant.input_City": "請選擇城市",
	"plant.input_Address": "請輸入地址",
	"plant.input_TimeZone": "請選擇時區",
	"plant.input_Energyprice": "請輸入單價",
	"plant.input_IncomeUnit": "選擇收入單位",
	"plant.max_20": "字元最大不能超過20個",
	"plant.max_5": "字元最大不能超過5個",
	"plant.max_8": "字元最大不能超過8個",
	"plant.format": "請輸入正確的格式",
	"plant.close": "關閉",
	"plant.submit": "提交",
	"plant.title_delete": "刪除？",
	"plant.no": "否",
	"plant.yes": "是",
	"datalog.email": "請輸入郵箱",
	"datalog.datalogSn": "請輸入採集器序列號",
	"datalog.search": "搜索",
	"datalog.Version": "版本號",
	"datalog.setting": "設置",
	"datalog.upgrade": "升級",
	"datalog.delete": "刪除",
	"datalog.title_datalog": "採集器設置",
	"datalog.span_info": "資訊",
	"datalog.span_datalog": "採集器序列號:",
	"datalog.span_name": "別名:",
	"datalog.span_time": "更新時間:",
	"datalog.span_firmware": "信號/固件版本:",
	"datalog.span_order": "命令",
	"datalog.span_settingdns": "設置域名",
	"datalog.span_inputsetting": "請輸入域名",
	"datalog.span_upgrade": "升級採集器",
	"datalog.span_reset": "重啟採集器",
	"datalog.span_setup": "高級設置",
	"datalog.span_param": "參數",
	"datalog.span_value": "值",
	"datalog.btn_setup": "高級設置",
	"datalog.btn_setting": "設置",
	"datalog.btn_settingdns": "設置域名",
	"datalog.btn_upgrade": "升級",
	"datalog.btn_reset": "重啟",
	"datalog.btn_read": "讀取",
	"datalog.btn_close": "取消",
	"datalog.methods_version": "檢測版本更新?",
	"datalog.no": "否",
	"datalog.yes": "是",
	"datalog.methods_delete": "刪除?",
	"datalog.methods_rereset": "重啟?",
	"datalog.methodes_inputDns": "請輸入域名",
	"datalog.methodes_DNS": "是否設置此域名",
	"sotrage.select": "請選擇",
	"sotrage.email": "請輸入郵箱",
	"sotrage.datalogSn": "請輸入採集器序列號",
	"sotrage.deviceSn": "請輸入設備序列號",
	"sotrage.search": "搜索",
	"sotrage.sotrage": "儲能設置",
	"device.select": "請選擇",
	"device.email": "請輸入郵箱",
	"device.datalogSn": "請輸入採集器序列號",
	"device.deviceSn": "請輸入設備序列號",
	"device.search": "搜索",
	"device.title": "逆變器設置",
	"device.setting": "設置",
	"device.setting_inverte": "設置逆變器參數",
	"device.input_start_address": "起始寄存器地址",
	"device.input_ent_address": "終止寄存器地址",
	"device.input_setting_value": "請輸入設置值",
	"device.read_data": "讀取寄存器數據:",
	"device.input_start_read": "起始寄存器地址",
	"device.input_end_read": "終止寄存器地址",
	"device.btn_address": "設置地址",
	"device.btn_value": "設置參數",
	"device.btn_read": "讀取",
	"device.btn_close": "返回",
	"device.selet_data": "選擇日期",
	"battery.select": "請選擇",
	"battery.email": "請輸入郵箱",
	"battery.datalogSn": "請輸入採集器序列號",
	"battery.deviceSn": "請輸入設備序列號",
	"battery.search": "搜索",
	"socket.title": "插座設置",
	"socket.setting": "設置",
	"socket.span": "設置了多個寄存器地址，值也要設置多個。 設置值中間要用 , 隔開，示例（1，2，3）",
	"socket.setting_device": "設置逆變器參數：",
	"socket.startaddress": "起始寄存器地址",
	"socket.stopaddress": "終止寄存器地址",
	"socket.value": "請輸入設置值",
	"socket.readdata": "讀取寄存器數據：",
	"socket.setting_address": "設置地址",
	"socket.setting_value": "設置參數",
	"socket.read": "讀取",
	"socket.return": "返回",
	"agent.close": "取消",
	"agent.submit": "提交",
	"agent.input_email": "請輸入郵箱",
	"agent.search": "搜索",
	"agent.add_agent": "添加代理商",
	"agent.import_device": "導入設備",
	"agent.edit": "編輯",
	"agent.title": "添加代理商",
	"agent.email": "郵箱",
	"agent.password": "密碼",
	"agent.phone": "手機號碼",
	"agent.company": "公司",
	"agent.language": "語言",
	"agent.address": "地址",
	"agent.input_password": "請輸入密碼",
	"agent.input_phone": "請輸入手機號",
	"agent.input_company": "請選擇公司",
	"agent.input_language": "請輸入語言",
	"agent.input_address": "請輸入地址",
	"agent.relus_email": "請輸入有效的電子郵件地址",
	"agent.title_edit": "編輯代理商",
	"agent.title_device": "上傳",
	"agent.span": "示例: Excle 表格",
	"agent.btn_upload": "上傳",
	"agent.delete": "刪除",
	"agent.agent_delete": "刪除代理商?",
	"ship.starttime": "開始時間",
	"ship.endtime": "結束時間",
	"ship.deviceSn": "請輸入設備序列號",
	"ship.select": "請選擇公司",
	"ship.search": "搜索",
	"Firmware.file_name": "請輸入檔案名字",
	"Firmware.search": "搜索",
	"Firmware.add": "添加",
	"Firmware.delete": "刪除",
	"Firmware.title": "固件上傳",
	"Firmware.select_folder": "選擇資料夾:",
	"Firmware.select_folder_type": "請選擇資料夾類型",
	"Firmware.craete_folder": "建立一個新的資料夾",
	"Firmware.folder_path": "資料夾路徑：",
	"Firmware.folder_name": "文件名稱:",
	"Firmware.input_folder_name": "輸入資料夾名稱",
	"Firmware.create": "建立資料夾",
	"Firmware.listed_files": "文件列表：",
	"Firmware.import_folder": "導入文件",
	"Firmware.uplad_folder": "上傳文件",
	"Firmware.close": "返回",
	"Upgrade.starttime": "開始時間",
	"Upgrade.endtime": "結束時間",
	"Upgrade.deviceSn": "請輸入設備序列號",
	"Upgrade.type": "請選擇類型",
	"Upgrade.search": "搜索",
	"Upgrade.datalog": "採集器",
	"Upgrade.Inverter": "逆變器",
	"Upgrade.Control": "控制器",
	"datalogs_logs.starttime": "開始時間",
	"datalogs_logs.endtime": "結束時間",
	"datalogs_logs.deviceSn": "請輸入設備序列號",
	"datalogs_logs.Version": "請輸入版本",
	"datalogs_logs.search": "搜索",
	"Logs.starttime": "開始時間",
	"Logs.endtime": "結束時間",
	"Logs.deviceSn": "請輸入設備序列號",
	"Logs.type": "請選擇類型",
	"Logs.search": "搜索",
	"Special.starttime": "開始時間",
	"Special.endtime": "結束時間",
	"Special.deviceSn": "請輸入設備序列號",
	"Special.datalogSn": "請輸入採集器序號",
	"Special.type": "請選擇類型",
	"Special.search": "搜索",
	"Special.save": "保存",
	"Special.Examples": "範例：(2305210230,2305210139)",
	"App.System_Config": "系统配置",
	"App.APP_Version": "App版本發佈",
	"App.Android_Version": "安卓版本:",
	"App.IOS_Version": "IOS版本:",
	"App.APP_Type": "App類型:",
	"App.New_Version": "新版本",
	"App.update_content": "更新內容描述:(用“/n”來劃分)",
	"App.Whether_update": "是否強制更新：",
	"App.no": "否",
	"App.yes": "是",
	"App.submit": "提交",
	"Tips.app_submit": "确定修改信息?",
	"Tips.firmware_delete": "確認刪除?",
	"Tips.firmware_deleteCDN": "刪除CDN中的文件?",
	"Tips.yes": "是",
	"Tips.no": "否",
	"global.DataDetails": "資料詳情",
	"global.device": "逆變器設置",
	"global.device_data": "設置逆變器參數:",
	"global.storage": "儲能設置",
	"global.storage_data": "設置儲能參數",
	"global.battery": "電池設置",
	"global.battery_data": "設置電池參數",
	"global.socket": "插座設置",
	"global.socket_data": "設置插座參數",
	"btn.setting_address": "設置地址",
	"btn.close": "關閉",
	"btn.submit": "提交",
	"btn.Setting_parameters": "設置參數",
	"btn.Reading": "讀取",
	"btn.search": "搜索",
	"btn.add": "添加",
	"btn.import": "導入",
	"btn.download": "下載示例",
	"btn.edit": "編輯",
	"btn.login": "登錄",
	"btn.export": "匯出",
	"form.addShip": "添加出貨設備",
	"form.editShip": "編輯出貨設備",
	"form.import": "導入設備資訊",
	"form.shipSN": "出貨序列號",
	"form.agent": "代理商",
	"form.networkCall": "是否執行配網回調",
	"form.warrantyPeriod": "質保時間",
	"form.shiptime": "出貨時間",
	"form.shiptype": "出貨類型",
	"form.classify": "分類",
	"form.file": "將檔案拖放到此處或點擊上傳",
	"form.edit_plant": "編輯場景",
	"form.input_station": "請輸入場景名稱",
	"form.lable_StationName": "場景名稱",
	"form.lable_StationType": "場景類型",
	"form.input_StationName": "請輸入場景名稱",
	"form.edit_plant_plant": "編輯電廠",
	"form.input_station_plant": "請輸入電廠名稱",
	"form.lable_StationName_plant": "電廠名稱",
	"form.lable_StationType_plant": "電廠類型",
	"form.input_StationName_plant": "請輸入電廠名稱",
	"placeholder.select": "請選擇",
	"placeholder.choiceCountry": "請選擇國家",
	"placeholder.choiceTimezone": "請選擇時區",
	"placeholder.enterEmail": "請輸入郵箱",
	"placeholder.enterPhone": "請輸入手機號",
	"placeholder.verificationCode": "請輸入驗證碼",
	"placeholder.enterPassword": "請輸入6-20位密碼",
	"placeholder.confirmPassword": "請確認密碼",
	"placeholder.readAndAgree": "我已經閱讀並同意",
	"placeholder.search": "搜索",
	"placeholder.searchPlantName": "搜索電站名字",
	"placeholder.searchDeviceName": "搜索設備名字",
	"placeholder.searchDataloggerName": "搜索採集器名字",
	"placeholder.enterPlantName": "請輸入電站名字",
	"placeholder.enterPlantType": "請輸入電站类型",
	"placeholder.enterPVCapacity": "請輸入PV容量",
	"placeholder.choiceInstallationDate": "請選擇安裝日期",
	"placeholder.enterPlantAddress": "請輸入電站地址",
	"placeholder.enterOldPassword": "請輸入舊密碼",
	"placeholder.enterNewPassword": "請輸入新密碼",
	"placeholder.enterConfirmPassword": "請確認新密碼",
	"placeholder.enter": "請輸入{scope}",
	"placeholder.selectScope": "請選擇{scope}",
	"placeholder.country": "國家",
	"placeholder.city": "城市",
	"placeholder.scanCodeAddPlant": "請掃碼添加電站!",
	"placeholder.currentNoPlant": "當前沒有電站，請點擊添加!",
	"placeholder.selectRepeatTime": "請選擇重複時間",
	"placeholder.enterDatalogger": "請輸入採集器序列號",
	"placeholder.enterDeviceSN": "請輸入設備序列號",
	"setting.general.needGreat": "需要大於",
	"setting.general.needSmall": "需要小於",
	"setting.general.gapScope": "輸入參數的間隔是",
	"setting.general.valScope": "輸入參數的范圍是",
	"setting.socket.switchStatus": "插座開關",
	"setting.socket.repetition": "重復時間",
	"setting.socket.enableOrNot": "是否啟用",
	"setting.socket.monday": "週一",
	"setting.socket.tuesday": "週二",
	"setting.socket.wednesday": "週三",
	"setting.socket.thursday": "週四",
	"setting.socket.friday": "週五",
	"setting.socket.saturday": "週六",
	"setting.socket.sunday": "週日",
	"setting.type3.dischargeScheduleMode": "定時放電模式",
	"setting.type3.timeDischarge": "定時放電",
	"setting.type3.workingDay": "工作日",
	"setting.type3.weekend": "週末",
	"setting.type3.pureLightControlMode": "純光控模式",
	"setting.type3.stopDischarge": "SOC低端停止放電設定值",
	"setting.type3.chargeTransferDischarge": "SOC充滿轉放電設定值",
	"setting.type3.batterySOCSetting": "電池SOC設置",
	"setting.type3.lowBatteryAlam": "電池 SOC 低端告警設定值",
	"setting.type3.lowBatteryShutdown": "電池 SOC 低端停止放電設定值",
	"setting.type3.systemSetting": "系統設置",
	"setting.type3.systemWorkMode": "系統工作模式",
	"setting.type3.restoreFactory": "恢復出廠設置",
	"setting.type3.loadMode": "負載模式",
	"setting.type3.timingDischarge": "定時放電模式",
	"setting.type3.DCOutputNormallyClosed": "直流輸出常閉模式",
	"setting.type3.DCOutputNormallyOpen": "直流輸出常開模式",
	"setting.type3.ForcedPowerProtection": "強制保電模式",
	"setting.type3.mode": "模式",
	"setting.type3.startTime": "開始時間",
	"setting.type3.stopTime": "結束時間",
	"setting.type3.onlyAddThree": "最多添加21個定時器",
	"setting.type3.startCompareEnd": "定時器的開始時間只能小於結束時間",
	"setting.type3.confirmClose": "你確定要關機嗎？",
	"setting.type6.countryCode": "國家編號",
	"setting.type6.poweradjppm": "逆變器功率調節速度",
	"setting.type6.enaINVTR": "遠程開關機",
	"setting.type6.enaSysProtIF_selfCheck": "系統保護接口自檢",
	"setting.type6.enaRestoretodefault": "恢復默認值",
	"setting.type6.UV_resopnseTime": "{num}級欠壓響應時間",
	"setting.type6.UF_resopnseTime": "{num}級欠頻響應時間",
	"setting.type6.OV_resopnseTime": "{num}級過壓響應時間",
	"setting.type6.OF_resopnseTime": "{num}級過頻響應時間",
	"setting.type6.open": "開啟",
	"setting.type6.recover": "恢復",
	"setting.type6.noHave": "無",
	"setting.type6.activePowerSwitch": "有功功率率開關",
	"setting.type6.activePowerPermillage": "有功功率千分比",
	"setting.type7.paramterSetting": "參數設置",
	"setting.type7.batteryVoltage": "蓄電池電壓",
	"setting.type7.batteryCapacity": "蓄電池容量",
	"setting.type7.PVChargingCurrent": "光伏充電電流",
	"setting.type7.overVoltage": "超壓電壓",
	"setting.type7.chargingLimitVoltage": "充電限制電壓",
	"setting.type7.increaseChargeReturnVoltage": "提升充電返回電壓",
	"setting.type7.overDischargeVoltage": "過放電壓",
	"setting.type7.stopchangeCurrent": "停止充電電流",
	"setting.type7.inverter485Address": "485地址",
	"setting.type7.passwordValue": "用戶密碼",
	"setting.type7.inputPassword": "密碼輸入",
	"setting.type7.recordFaultCodes": "記錄故障碼",
	"setting.type7.isOpen": "開關機控制",
	"setting.type7.equalizingChargeCmd": "立即充電均衡",
	"setting.type7.reset": "復位控製",
	"setting.type7.factory": "恢復出廠設置",
	"setting.type7.clearAlarm": "清除當前告警",
	"setting.type7.clearHistory": "清除歷史記錄",
	"setting.type7.generatorSwitchCmd": "發電機切換",
	"setting.type7.nowTimeStr": "當前時間",
	"setting.type7.setVal.reset": "復位",
	"setting.type7.setVal.recover": "恢復",
	"setting.type7.setVal.clearAlarm": "清除告警",
	"setting.type7.setVal.clearHistory": "清除歷史",
	"setting.type7.setVal.toggle": "切換",
	"setting.type8.systemSwitch": "系統開關",
	"setting.type10.modeSelect": "模式選擇",
	"setting.type10.standbyMode": "備電模式",
	"setting.type10.PureOffGrid": "純離網啟動模式",
	"setting.type10.energyNet": "能量上網",
	"setting.type10.inverter0": "逆變補能量到本地負載",
	"setting.type10.inverter1": "逆變給電網發電",
	"setting.type10.inverter2": "逆變給本地負載帶CT",
	"setting.type10.inverter3": "逆變給本地負載智能插座或者智能電錶",
	"setting.type10.chargePriority": "充電優先級",
	"setting.type10.PVPriority": "光伏優先",
	"setting.type10.utilityPriority": "市電優先",
	"setting.type10.hybridModel": "混合模式",
	"setting.type10.PVOnly": "僅光伏",
	"setting.type10.batteryLowAlarm": "電池SOC低告警值",
	"setting.type10.batteryLowShutdown": "電池SOC低關機點",
	"setting.type10.batteryFull": "電池充飽SOC判斷值",
	"setting.type10.ACCharging": "AC充電",
	"setting.type10.startTime": "起始時間",
	"setting.type10.endTime": "結束時間",
	"setting.type10.forcedDischarge": "強制放電",
	"setting.type10.phaseGridSide": "相電網側",
	"setting.type10.power": "有功率",
	"setting.type10.current": "電流",
	"setting.type10.gridConnectionStandard": "並網標準",
	"setting.type10.baudRate": "485波特率",
	"setting.type10.disable": "失能",
	"setting.type10.enable": "使能",
	"setting.type10.ApprovalStandards": "認證標準",
	"setting.type10.antiRefluxPower": "防逆流功率",
	"setting.type10.antiRefluxSet": "防逆流使能",
	"setting.type10.batFullSocSet": "電池充飽SOC判斷值(%)",
	"setting.type10.auxSourceSet": "輔源開關",
	"setting.type10.timeSharingGridConnectedDischarge": "分時併網放電",
	"setting.type10.timeSharingGridConnection": "分時併網",
	"setting.type10.outputPower": "輸出功率",
	"setting.type10.onlyAddThree": "最多添加{num}個定時器",
	"setting.type10.productModelNumber": "產品型號",
	"setting.type10.PleaseTurnOnThe_PCS_switchFirst": "請先打開 PCS 開關",
	"setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "充放電時間有衝突",
	"setting.type10.ChargeDischargeTimeSetting": "充電&放電 時間設置",
	"setting.type11.switchPCS": "PCS開關",
	"setting.type11.functionSwitch": "功能開關",
	"setting.type11.maxChargeVol": "最高充電電壓（V）",
	"setting.type11.onGridMinDischargeVol": "並網最低放電電壓（V）",
	"setting.type11.offGridOutputVol": "離網輸出電壓（V）",
	"setting.type11.maxChargeCur": "最高充電電流(A)",
	"setting.type11.onGridMaxDischargeCur": "並網最高放電電流(A)",
	"setting.type11.offGridMaxDisChargeCur": "離網最高放電電流(A)",
	"setting.type11.minSocBMS": "BMS最小SOC（%）",
	"setting.type11.minSocDischarge": "智能放電最小SOC（%）",
	"setting.type11.maxSocDischarge": "智能放電最大SOC（%）",
	"setting.type11.timeStr": "設備時間",
	"setting.type11.timerSetting": "定時器設置{num}",
	"setting.type11.chargeStartTime1": "起始充電時間1",
	"setting.type11.chargeLongTime1": "充電時長1",
	"setting.type11.chargeTimeMaxSOC1": "充電時段 1 最大SOC（%）",
	"setting.type11.chargeTimeCurrent1": "充電時段 1 充電電流(A)",
	"setting.type11.dischargeStartTime1": "起始放電時間1",
	"setting.type11.dischargeLongTime1": "放電時長1",
	"setting.type11.dischargeTimeMaxSOC1": "放電時段 1 最小SOC（%）",
	"setting.type11.dischargeTimeCurrent1": "放電時段 1 放電電流(A)",
	"setting.type11.chargeStartTime2": "起始充電時間2",
	"setting.type11.chargeLongTime2": "充電時長2",
	"setting.type11.chargeTimeMaxSOC2": "充電時段 2 最大SOC（%）",
	"setting.type11.chargeTimeCurrent2": "充電時段 2 充電電流(A)",
	"setting.type11.dischargeStartTime2": "起始放電時間2",
	"setting.type11.dischargeLongTime2": "放電時長2",
	"setting.type11.dischargeTimeMaxSOC2": "放電時段 2 最小SOC（%）",
	"setting.type11.dischargeTimeCurrent2": "放電時段 2 放電電流(A)",
	"setting.type11.chargeStartTime3": "起始充電時間3",
	"setting.type11.chargeLongTime3": "充電時長3",
	"setting.type11.chargeTimeMaxSOC3": "充電時段 3 最大SOC（%）",
	"setting.type11.chargeTimeCurrent3": "充電時段 3 充電電流(A)",
	"setting.type11.dischargeStartTime3": "起始放電時間3",
	"setting.type11.dischargeLongTime3": "放電時長3",
	"setting.type11.dischargeTimeMaxSOC3": "放電時段 3 最小SOC（%）",
	"setting.type11.dischargeTimeCurrent3": "放電時段 3 放電電流(A)",
	"setting.type11.chargeStartTime4": "起始充電時間4",
	"setting.type11.chargeLongTime4": "充電時長4",
	"setting.type11.chargeTimeMaxSOC4": "充電時段 4 最大SOC（%）",
	"setting.type11.chargeTimeCurrent4": "充電時段 4 充電電流(A)",
	"setting.type11.dischargeStartTime4": "起始放電時間4",
	"setting.type11.dischargeLongTime4": "放電時長4",
	"setting.type11.dischargeTimeMaxSOC4": "放電時段 4 最小SOC（%）",
	"setting.type11.dischargeTimeCurrent4": "放電時段 4 放電電流(A)",
	"setting.type11.functionSwitchObj.val1": "智能模式",
	"setting.type11.functionSwitchObj.val2": "定時模式",
	"setting.type11.functionSwitchObj.val3": "自發自用模式",
	"setting.type12.LEDSwitch": "LED開關",
	"setting.type12.LEDSpeed": "LED速度",
	"setting.type12.LEDEffect": "LED效果",
	"setting.type12.LEDBrightness": "LED亮度",
	"setting.type12.dataColor": "數據顏色表示",
	"setting.type12.LED1Color": "LED1 顏色",
	"setting.type12.LED2Color": "LED2 顏色",
	"setting.type12.LED3Color": "LED3 顏色",
	"setting.type12.buzzerAlarm": "蜂鳴器告警",
	"setting.type12.overLoadToBypass": "超載轉旁路",
	"setting.type12.lcdRestartPage": "LCD無操作恢復主界面",
	"setting.type12.overloadReset": "超載重啟",
	"setting.type12.overloadTemperature": "過溫重啟",
	"setting.type12.backLightOn": "LCD無操作背光",
	"setting.type12.inputSourceChangeAlarm": "輸入源變化告警",
	"setting.type12.faultCodeRecord": "通訊軟體故障記錄",
	"setting.type12.solarFeedToGird": "太陽能空閒並網",
	"setting.type12.switchOptions": "開關選項",
	"setting.type12.batteryParam": "電池參數",
	"setting.type12.outputParam": "輸出參數",
	"setting.type12.ratedOutputVol": "額定輸出電壓",
	"setting.type12.ratedOutputFreq": "額定輸出頻率",
	"setting.type12.inputVolRange": "輸入電壓範圍",
	"setting.type12.outPutSourcePriority": "輸出源優先",
	"setting.type12.batType": "電池類型",
	"setting.type12.batUnderVol": "電池截止電壓",
	"setting.type12.batBulkVol": "電池恒充電壓",
	"setting.type12.batFloatVol": "電池浮充電壓",
	"setting.type12.maxChargingCur": "最大充電電流",
	"setting.type12.maxAcChargingCur": "最大交流充電電流",
	"setting.type12.chargeSourcePriority": "充電器源優先順序",
	"setting.type12.batReChargeVol": "恢復充電電壓",
	"setting.type12.batFullRestoreDischargeVol": "恢復放電電壓",
	"setting.type12.solarSupplyPriority": "太陽能供電優先",
	"setting.type12.resetPvStorage": "重置PV統計數據",
	"setting.type12.countryRegulations": "國家法規",
	"setting.type12.acChargeStartTime": "交流充電器工作啟動時間",
	"setting.type12.acChargeEndTime": "交流充電器工作停止時間",
	"setting.type12.acSupplyStartTime": "交流電源的啟動時間",
	"setting.type12.acSupplyEndTime": "交流電源的停止時間",
	"setting.type12.restoreFactorySet": "恢復出廠設置",
	"setting.type12.parallelMode": "並機模式",
	"setting.type12.bulkChargeVol": "CV充電電壓",
	"setting.type12.batEquSet": "電池均充功能",
	"setting.type12.batEquTime": "電池均充時間（min）",
	"setting.type12.batEquDay": "電池均充間隔天數（d）",
	"setting.type12.batEquChargeVol": "電池均充電壓 (V)",
	"setting.type12.batEquTimeout": "電池均充超時時間(min)",
	"setting.type12.equInfoSet": "均衡信息設置",
	"setting.type12.val.slow": "慢",
	"setting.type12.val.medium": "中",
	"setting.type12.val.fast": "快",
	"setting.type12.val.low": "低",
	"setting.type12.val.high": "高",
	"setting.type12.val.powerCycle": "動力循環",
	"setting.type12.val.powerRotation": "動力輪替",
	"setting.type12.val.additionalPower": "動力追加",
	"setting.type12.val.powerUnchanged": "動力不變",
	"setting.type12.val.solarPowerInput": "太陽能輸入功率",
	"setting.type12.val.batteryCapacity": "電池容量百分比",
	"setting.type12.val.percentageLoad": "負載百分比",
	"setting.type12.val.energySource": "能量源",
	"setting.type12.val.batteryStatus": "電池充放電狀態",
	"setting.type12.val.blue": "藍色",
	"setting.type12.val.green": "綠色",
	"setting.type12.val.cyan": "青色",
	"setting.type12.val.pink": "粉色",
	"setting.type12.val.purple": "紫色",
	"setting.type12.val.orange": "橙色",
	"setting.type12.val.yellow": "黃色",
	"setting.type12.val.white": "白色",
	"setting.type12.val.inputOvlRange1": "APL 模式（90-280V）",
	"setting.type12.val.inputOvlRange2": "UPS 模式（170-280V）",
	"setting.type12.val.outputSource1": "太陽能->公用->電池",
	"setting.type12.val.outputSource2": "太陽能->電池->公用",
	"setting.type12.val.chargeSourcePriority1": "光伏優先",
	"setting.type12.val.chargeSourcePriority2": "光伏和市電",
	"setting.type12.val.chargeSourcePriority3": "僅光伏",
	"setting.type12.val.solarSupplyPriority1": "電池-負載-公用",
	"setting.type12.val.solarSupplyPriority2": "負載-電池-公用",
	"setting.type12.val.countryRegulations1": "印度",
	"setting.type12.val.countryRegulations2": "德國",
	"setting.type12.val.countryRegulations3": "南美洲",
	"setting.type12.val.parallelMode1": "無並機",
	"setting.type12.val.parallelMode2": "單相並機",
	"setting.type12.val.outPutSourcePriority1": "市電优先",
	"setting.type12.val.outPutSourcePriority2": "太陽能優先",
	"setting.type12.val.outPutSourcePriority3": "太陽能->電池->市電",
	"setting.ops15.invSwitch": "逆變器開關",
	"setting.ops15.workMode": "工作模式",
	"setting.ops15.workMode1": "餽網優先",
	"setting.ops15.workMode2": "離網模式",
	"setting.ops15.workMode3": "自發自用",
	"setting.ops15.invTime": "逆變器時間",
	"setting.ops15.batType": "電池類型",
	"setting.ops15.batType1": "無電池",
	"setting.ops15.batType2": "通用鋰電池",
	"setting.ops15.batType3": "鉛酸電池",
	"setting.ops15.batType4": "鋰電池",
	"setting.ops15.timingTime": "定時時間",
	"setting.ops15.offGirdSoc": "過放SOC(%)",
	"setting.ops15.optimizeRevenue": "優化收益",
	"setting.type19.totalActivePower": "有功功率",
	"setting.type19.offgridSettings": "並離網設置",
	"setting.type19.gridConnectedControlMode": "並網控制",
	"setting.type19.offGridControlMode": "離網控制",
	"setting.type19.offgrid.gridNet": "並網",
	"setting.type19.offgrid.offNet": "離網",
	"setting.type22.parameterScope": "參數範圍",
	"setting.type22.ACStartVoltage": "啟動電壓/頻率設置",
	"setting.type22.highVoltage": "AC啟動高壓",
	"setting.type22.lowVoltage": "AC啟動低壓",
	"setting.type22.pvStartLowVol": "PV啟動低壓",
	"setting.type22.acUnderVol1": "AC欠壓一階(V)",
	"setting.type22.acOverVol1": "AC過壓一階(V)",
	"setting.type22.acUnderVolTime1": "AC欠壓一階時間(s)",
	"setting.type22.acOverVolTime1": "AC過壓一階時間(s)",
	"setting.type22.acUnderVol2": "AC欠壓二階(V)",
	"setting.type22.acOverVol2": "AC過壓二階(V)",
	"setting.type22.acUnderVolTime2": "AC欠壓二階時間(s)",
	"setting.type22.acOverVolTime2": "AC過壓二階時間(s)",
	"setting.type22.startDelayTime": "啟動延時時間",
	"setting.type22.restartDelayTime": "重啟延時時間",
	"setting.type22.ACStartFrequency": "過欠壓/頻設置",
	"setting.type22.highFrequency": "AC啟動高頻",
	"setting.type22.lowFrequency": "AC啟動低頻",
	"setting.type22.acUnderFrequency1": "AC欠頻一階(Hz)",
	"setting.type22.acOverFrequency1": "AC過頻一階(Hz)",
	"setting.type22.acUnderFrequencyTime1": "AC欠頻一階時間(s)",
	"setting.type22.acOverFrequencyTime1": "AC過頻一階時間(s)",
	"setting.type22.acUnderFrequency2": "AC欠頻二階(Hz)",
	"setting.type22.acOverFrequency2": "AC過頻二階(Hz)",
	"setting.type22.acUnderFrequencyTime2": "AC欠頻二階時間（s）",
	"setting.type22.acOverFrequencyTime2": "AC過頻二階時間（s）",
	"setting.type22.systemSetting": "設備信息設置",
	"setting.type22.SNset": "序列號設置",
	"setting.type22.reactiveControlMode": "無功控制方式",
	"setting.type22.inputMode": "輸入模式",
	"setting.type22.startSolpe": "啟動斜率",
	"setting.type22.restartSolpe": "重啟斜率",
	"setting.type22.reactivePercentage": "無功百分比",
	"setting.type22.activePercentage": "有功百分比",
	"setting.type22.shutdown": "遠程開關",
	"setting.type22.functionSelect": "功能選擇",
	"setting.type22.manufacturer": "廠商",
	"setting.type22.setFunctionSelect.val1": "英威騰",
	"setting.type22.setFunctionSelect.val2": "創維",
	"setting.type22.setManufacturer.val1": "禁止",
	"setting.type22.setManufacturer.val2": "使能防逆流",
	"setting.type22.reactiveControlModeChoice.val1": "功率因數控制",
	"setting.type22.reactiveControlModeChoice.val2": "無功功率百分比控制",
	"setting.type22.reactiveControlModeChoice.val3": "QV曲線控制",
	"setting.type22.inputModeChoice.val1": "輸入獨立模式",
	"setting.type22.inputModeChoice.val2": "輸入變臉模式",
	"setting.type22.inputModeChoice.val3": "DC Source 模式",
	"title.login": "登錄",
	"title.vistorLogin": "遊客登錄",
	"title.createAccount": "創建帳戶",
	"title.retrievePassword": "找回密碼",
	"title.userAgreement": "用戶協議",
	"title.privacyPolicy": "隱私協議",
	"title.phone": "電話",
	"title.addPlant": "添加電站",
	"title.editPlant": "編輯電站",
	"title.accountInfo": "帳戶資訊",
	"title.changePassword": "修改密碼",
	"title.message": "消息",
	"title.systemMessage": "系統消息",
	"title.faultMessage": "故障消息",
	"title.deviceMessage": "設備消息",
	"title.aboutUs": "關於",
	"title.device": "設備",
	"title.datalogger": "採集器",
	"title.setting": "設置",
	"title.socketSetting": "插座設置",
	"title.addSchedule": "添加定時器",
	"title.editSchedule": "編輯定時器",
	"title.repetitionTime": "重復時間",
	"title.addDatalogger": "添加設備",
	"title.connectWifi": "鏈接路由",
	"title.distributionNetworkStatus": "配網狀態",
	"title.language": "語言",
	"title.selectCountry": "選擇國家",
	"title.selectCity": "選擇城市",
	"bar.home": "首頁",
	"bar.energy": "分析",
	"bar.plant": "電站",
	"bar.user": "用戶",
	"bar.endpoint": "終端",
	"bar.mine": "我的",
	"bar.my": "我的",
	"button.logOut": "退出",
	"button.rememberMe": "記住賬號密碼",
	"button.forgetPassword": "忘記密碼",
	"button.register": "註冊",
	"button.ok": "確認",
	"button.send": "發送",
	"button.auto": "自動",
	"button.cancle": "取消",
	"button.yes": "是",
	"button.close": "關閉",
	"button.refresh": "刷新",
	"button.next": "下一步",
	"button.redistributionNetwork": "重新配網",
	"button.upload": "上傳",
	"button.confirm": "確認",
	"button.edit": "編輯",
	"button.delete": "刪除",
	"button.save": "保存",
	"button.allReady": "全部已讀",
	"button.selectAll": "全選",
	"button.deselectAll": "取消全選",
	"button.unsubscribe": "註銷賬戶",
	"button.later": "稍後",
	"button.upgrade": "更新",
	"button.unfollow": "取消關注",
	"button.add": "添加",
	"subtitle.NeedMoreHelp": "更多幫助",
	"subtitle.VisitSupportCenter": "瀏覽官網獲得更多幫助",
	"subtitle.energyFlowDiagram": "能流圖",
	"subtitle.selectTimezone": "選擇時區",
	"subtitle.selectPlantType": "選擇電站類型",
	"subtitle.selectInstallationDate": "選擇安裝日期",
	"subtitle.selectCurrency": "選擇貨幣",
	"subtitle.selectDateType": "選擇日期類型",
	"subtitle.selectDeviceType": "選擇設備類型",
	"subtitle.socketBluetooth": "插座藍牙",
	"subtitle.log": "日誌",
	"subtitle.all": "全部",
	"subtitle.online": "在線",
	"subtitle.offline": "離線",
	"subtitle.normal": "正常",
	"subtitle.abnormal": "異常",
	"subtitle.on": "開",
	"subtitle.off": "關",
	"subtitle.todayEnergy": "今日電量",
	"subtitle.totalEnergy": "總電量",
	"subtitle.totalRevenue": "總收入",
	"subtitle.plantImage": "電站圖片",
	"subtitle.plantName": "電站名字",
	"subtitle.plantType": "電站類型",
	"subtitle.PVCapacity": "PV容量",
	"subtitle.installationDate": "安裝日期",
	"subtitle.plantAddress": "電站地址",
	"subtitle.revenue": "收入",
	"subtitle.timeZone": "時區",
	"subtitle.updatePhone": "更新電話",
	"subtitle.solar": "光伏",
	"subtitle.grid": "電網",
	"subtitle.battery": "電池",
	"subtitle.home": "負載",
	"subtitle.load": "負載",
	"subtitle.socket": "插座",
	"subtitle.today": "日",
	"subtitle.day": "日",
	"subtitle.month": "月",
	"subtitle.year": "年",
	"subtitle.total": "總",
	"subtitle.time": "時間",
	"subtitle.Co2": "二氧化碳",
	"subtitle.coal": "煤",
	"subtitle.deforestation": "保護森林",
	"subtitle.parameter": "參數",
	"subtitle.schedule": "計時器",
	"subtitle.countdown": "倒計時",
	"subtitle.socketSwitch": "插座開關",
	"subtitle.currency": "貨幣",
	"subtitle.energyPrice": "電價",
	"subtitle.storagePlant": "儲能電站",
	"subtitle.on-GridPlant": "并網電站",
	"subtitle.photo": "頭像",
	"subtitle.email": "郵箱",
	"subtitle.account": "賬戶",
	"subtitle.version": "版本",
	"subtitle.officalWebsite": "官網",
	"subtitle.SN": "序列號",
	"subtitle.wifiSignal": "WiFi 信號",
	"subtitle.lastSync": "最後同步",
	"subtitle.switch": "開關",
	"subtitle.happening": "發生中",
	"subtitle.restored": "已恢復",
	"subtitle.details": "详情",
	"subtitle.warn": "告警",
	"subtitle.fault": "故障",
	"subtitle.status": "狀態",
	"subtitle.level": "等級",
	"subtitle.deviceType": "設備類型",
	"subtitle.alarmStartTime": "告警開始時間",
	"subtitle.alarmEndTime": "告警結束時間",
	"subtitle.solution": "解決方法",
	"subtitle.loginIn": "登錄中……",
	"subtitle.checkVersion": "檢查更新",
	"subtitle.versionUpgrade": "版本更新",
	"subtitle.messageDetail": "消息詳情",
	"subtitle.todayConsumption": "今日耗電量",
	"subtitle.totalConsumption": "總耗電量",
	"subtitle.dataloggerSN": "採集器序列號",
	"subtitle.configurationGuidance": "配置指導",
	"subtitle.guideVideo": "指導視頻",
	"subtitle.manualInstuction": "指導手冊",
	"subtitle.manualInstuction4G": "4G指導手冊",
	"subtitle.manualInstuctionMasterControl": "主控指導手冊",
	"subtitle.masterControlConfiguration": "主控配網",
	"subtitle.defaultConfiguration": "默認配網",
	"subtitle.findEmail": "郵箱找回",
	"subtitle.findPhone": "手機找回",
	"subtitle.family": "家庭",
	"subtitle.agent": "代理商",
	"subtitle.endUsers": "終端用戶",
	"subtitle.deviceManagement": "設備管理",
	"subtitle.deviceSN": "設備序列號",
	"subtitle.firmwareVersion": "固件版本",
	"subtitle.alias": "別名",
	"subtitle.information": "信息",
	"subtitle.domainName": "域名",
	"subtitle.restartdatalogger": "重啟採集器",
	"subtitle.value": "值",
	"subtitle.customizable": "自定義",
	"subtitle.ready": "讀取",
	"subtitle.deviceDetails": "設備詳情",
	"subtitle.startAddress": "起始寄存器地址",
	"subtitle.endAddress": "終止寄存器地址",
	"subtitle.settingParam": "設置參數",
	"subtitle.tariffType": "電價類型",
	"subtitle.fixed": "固定",
	"subtitle.timeshare": "分時",
	"subtitle.addTime": "添加時間",
	"subtitle.notAllDay": "不是一整天",
	"subtitle.dealer": "經銷商",
	"subtitle.dealerNumber": "經銷商編號",
	"subtitle.toggle": "切換",
	"subtitle.environmentalBenefit": "環境效益",
	"subtitle.basicParam": "基本參數",
	"subtitle.realTimeParam": "實時參數",
	"subtitle.export": "導出",
	"subtitle.localDebug": "近端調試",
	"subtitle.mode": "方式",
	"subtitle.manuallyAdd": "手動添加",
	"subtitle.AttachTheDevice": "下掛設備",
	"subtitle.ammeter": "電錶",
	"subtitle.FeederPowerOnTheSameDay": "當日饋網電量",
	"subtitle.BatterySOC": "電池SOC",
	"subtitle.DailyChargingCapacityOfTheBattery": "電池當日充電量",
	"subtitle.DailyPowerConsumption": "當日消耗電量",
	"subtitle.CumulativePowerGeneration": "累計發電量",
	"subtitle.total2": "總計",
	"subtitle.run": "運行",
	"subtitle.StopIt": "停止",
	"subtitle.Optimizer": "優化器",
	"subtitle.DataGateways": "數據閘道",
	"subtitle.dataType": "數據類型",
	"subtitle.Model": "型號",
	"subtitle.TheAmountOfElectricityGeneratedToday": "今日發電量",
	"subtitle.CurrentPower": "當前功率",
	"subtitle.AllOptimizerWorkingStatus": "所有優化器工作狀態",
	"subtitle.WhenClosedAllOptimizersStopWorking": "關閉後，所有優化器將停止工作",
	"subtitle.TheDataGatewayRestarts": "數據網關重啟",
	"subtitle.Reboot": "重啟",
	"subtitle.Restarting": "重啟中",
	"subtitle.HardwareVersionNumber": "硬體版本號",
	"subtitle.SoftwareVersionNumber": "軟體版本號",
	"subtitle.OutputPower": "輸出功率",
	"subtitle.OutputVoltage": "輸出電壓",
	"subtitle.OutputCurrent": "輸出電流",
	"subtitle.InputPower": "輸入功率",
	"subtitle.InputVoltage": "輸入電壓",
	"subtitle.InputCurrent": "輸入電流",
	"subtitle.OperationalStatus": "運行狀態",
	"subtitle.temperature": "溫度",
	"subtitle.DeviceAddress": "設備地址",
	"subtitle.FeederMode": "饋網模式",
	"subtitle.StandbyMode": "備電模式",
	"subtitle.Off-gridMode": "離網模式",
	"subtitle.TimedChargingAndDischarging": "定時充放電",
	"subtitle.WorkingModeSettings": "工作模式設定",
	"subtitle.DeviceInformation": "設備信息",
	"subtitle.HMISoftwareVersion": "HMI軟體版本",
	"subtitle.DSPSoftwareVersion": "DSP軟體版本",
	"subtitle.ChargeAndDischargeTimePeriodSetting": "充放電時間段設定",
	"subtitle.ChargingPeriod": "充電時間段",
	"subtitle.DischargeTimePeriod": "放電時間段",
	"subtitle.BatteryMinimumSOC(%)": "電池最小SOC(%)",
	"subtitle.BatteryOvervoltageMethod(V)": "電池過壓法值(V)",
	"subtitle.BatteryUndervoltageThreshold(A)": "電池欠壓閾值(A)",
	"subtitle.ChargingCurrentLimit(A)": "充電限流(A)",
	"subtitle.DischargeCurrentLimit(A)": "放電限流(A)",
	"subtitle.Off-GridDischargeMinimumSOC(%)": "離網放電最小SOC(%)",
	"subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "離網2放電最小SOC(%)",
	"subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "離網2放電最小電池電壓(V)",
	"subtitle.Auto-replenishment": "自動補電",
	"subtitle.BatteryBMSActivationCommand": "電池BMS激活命令",
	"subtitle.ForcedFullCharge": "強制滿充",
	"subtitle.ForceCharge2": "強制充電2",
	"subtitle.ForceCharge1": "強制充電1",
	"subtitle.DischargeEnabled": "放電使能",
	"subtitle.ChargingEnabled": "充電使能",
	"subtitle.NumberOfOptimizers": "優化器數量",
	"subtitle.TheNameOfTheDevice": "設備名稱",
	"subtitle.GeneralSettings": "通用設定",
	"subtitle.Anti-backflowSwitch": "防逆流開關",
	"subtitle.ReflowPowerLimit(W)": "回流功率限制(W)",
	"subtitle.OptimizerNumber": "优化器编号",
	"subtitle.reset": "重置",
	"subtitle.areYouSure": "確定要重置嗎",
	"subtitle.PhysicalView": "物理視圖",
	"subtitle.LogicalView": "邏輯視圖",
	"subtitle.LayoutDrawing": "佈局圖",
	"tip.noData": "暫無數據",
	"tip.base.maxDistance": "最遠",
	"tip.base.minDistance": "最近",
	"tip.base.maxSize": "最大",
	"tip.base.minSize": "最小",
	"tip.request.loading": "加載中",
	"tip.request.netWork": "網絡連接失敗，請檢查網絡",
	"tip.request.connectServerFail": "無法連接到服務器",
	"tip.request.requestTimeout": "請求超時",
	"tip.validate.choiceCountry": "請先選擇一個國家",
	"tip.validate.country": "國家不能為空，請選擇國家",
	"tip.validate.timeZone": "時區不能為空，請選擇時區",
	"tip.validate.email": "郵箱格式錯誤，請輸入一個正確的郵箱",
	"tip.validate.verification": "請先發送驗證碼",
	"tip.validate.verificationError": "驗證碼錯誤，請輸入一個有效的驗證碼",
	"tip.validate.passwordFormTip": "請輸入一個6-20位由字母和數字组成的密碼",
	"tip.validate.passwordError": "密碼格式錯誤，請輸入一個6-20位由字母和數字组成的密碼",
	"tip.validate.passwordError2": "請輸入一個有效的密碼(密碼不應該包括任何特殊字符、符號和空格)",
	"tip.validate.validatePassword": "您輸入的兩個密碼不一致，請檢查後重新輸入",
	"tip.validate.confirmAgreement": "請您先閱讀並同意隱私協議",
	"tip.validate.plantName": "電站名字不能為空，請輸入電站名字",
	"tip.validate.plantType": "電站類型不能為空，請選擇電站類型",
	"tip.validate.pvCapacity": "太陽能電池容量不能為空，請輸入電池容量",
	"tip.validate.installationDate": "安裝日期不能為空，請選擇安裝日期",
	"tip.validate.city": "城市不能為空，請選擇城市",
	"tip.validate.incomeunit": "貨幣不能為空，請選擇貨幣",
	"tip.validate.energyPrice": "電價不能為空，請輸入電價",
	"tip.validate.firstChoiceCountry": "請先選擇一個國家",
	"tip.validate.oldPassword": "舊密碼不能為空，請輸入舊密碼",
	"tip.validate.newPassword": "新密碼不能為空，請輸入新密碼",
	"tip.validate.confirmPassword": "確認密碼不能為空，請確認密碼",
	"tip.validate.passwordNotMatch": "兩次密碼輸入不一致，請檢查確認後提交",
	"tip.validate.SN1": "序列號不能為空",
	"tip.validate.SN2": "序列號必須是10位",
	"tip.validate.noSocketTimer": "當前沒有插座定時器，請點擊添加",
	"tip.validate.cameraPermission": "App需要相機權限，以便用於掃碼添加採集器",
	"tip.validate.searchingState": "正在搜索藍牙中，請勿重複點擊",
	"tip.validate.notInTheScope": "輸入參數不在規定範圍內",
	"tip.validate.enterDecimal": "必須輸入{num}位小數或整數",
	"tip.validate.integer": "必須是整數",
	"tip.validate.phone": "手機號僅支持中國大陸，其它請使用郵箱找回",
	"tip.validate.can`tEmpty": "{param}不能為空",
	"tip.validate.dealerSope": "經銷商編號範圍是6~8位數字",
	"tip.validate.firstChoicePlant": "請先選擇電站",
	"tip.log.permissionOpen": "確保定位和藍牙權限已開啟",
	"tip.log.openBluetoothSystem": "打開藍牙設置",
	"tip.log.openIosBtSystem": "請重啟藍牙開關",
	"tip.log.openLocationSystem": "打開定位設置",
	"tip.log.bluetoothAuthorization": "APP藍牙授權未開啟",
	"tip.log.locationAuthorization": "APP定位授權未開啟",
	"tip.log.searchSurroundingDevicesPermission": "搜索附近設備未授權",
	"tip.log.bluetoothNotPermission": "藍牙未開啟",
	"tip.log.locationNotPermission": "定位未開啟",
	"tip.log.bluetoothPermission": "藍牙已開啟",
	"tip.log.locationPermission": "定位已開啟",
	"tip.log.bluetoothException": "藍牙異常斷開，請確認設備藍牙石已開啟，然後重新連接",
	"tip.log.listeningFailure": "監聽特征值變化失敗，請重新連接藍牙",
	"tip.log.communicationException": "藍牙通訊異常，請重新連接藍牙",
	"tip.log.reconnect": "藍牙重新連接",
	"tip.log.connectFail": "藍牙連接失敗",
	"tip.log.connect": "連接藍牙",
	"tip.log.bluetoothService": "請開啟藍牙服務",
	"tip.log.locationService": "請開啟定位服務",
	"tip.log.notsupport": "當前平台支持調用藍牙功能",
	"tip.log.locationNotTurnOn": "定位未開啟，無法搜索藍牙",
	"tip.log.init": "藍牙初始化",
	"tip.log.searching": "正在搜索周圍藍牙",
	"tip.log.searchFail": "周圍沒有查詢到設備，請確保設備藍牙已開啟，然後點擊刷新",
	"tip.log.stopSearch": "停止搜索周圍藍牙",
	"tip.log.stopSearchFail": "停止搜索周圍藍牙失敗",
	"tip.log.connectSuccess": "藍牙連接成功",
	"tip.log.setMTUsSuccess": "設置最大傳輸單元成功",
	"tip.log.setMTUsFail": "設置最大傳輸單元失敗",
	"tip.log.closeSuccess": "已斷開藍牙連接",
	"tip.log.closeFail": "斷開藍牙連接失敗",
	"tip.log.wifiLoadFail": "WiFi列表加載失敗，請手動輸入",
	"tip.log.bluetoothAbnormal": "藍牙連接異常，正在嘗試重新連接",
	"tip.log.getBluetoothServiceSuccess": "獲取藍牙設備服務成功",
	"tip.log.getBluetoothServiceFail": "獲取藍牙設備服務失敗",
	"tip.log.getFeatureValuesSucess": "已成功獲取藍牙設備指定服務中的所有特征值",
	"tip.log.getFeatureValuesFail": "獲取藍牙設備指定服務中的所有特征值失敗",
	"tip.log.subscriptionEigenvalueSuccess": "已啟用低功耗藍牙設備特征值變化時的notify功能，訂閱特征值",
	"tip.log.subscriptionEigenvalueFail": "啟用低功耗藍牙設備特征值變化時的notify功能，訂閱特征值失敗",
	"tip.log.monitoringSuccess": "已成功監聽低功耗藍牙設備的特征值變化事件",
	"tip.log.monitoringFail": "監聽低功耗藍牙設備的特征值變化事件失敗",
	"tip.log.CRC": "CRC校驗失敗",
	"tip.log.queryWiFi": "已成功查詢WiFi列表",
	"tip.log.queryWiFiState": "已成功下發WiFi列表查詢指令",
	"tip.log.wifiConenct": "正在查詢路由連接狀態",
	"tip.log.wifiFail": "請檢查路由器賬號和密碼並嘗試重新連接",
	"tip.log.connectWiFiSuccess": "路由器連接成功",
	"tip.log.connectWiFiFail": "路由器連接失敗",
	"tip.log.routerAccount": "路由器賬號錯誤",
	"tip.log.routerPassword": "路由器密碼錯誤",
	"tip.log.gettingIP": "正在獲取路由器IP",
	"tip.log.getIPFail": "獲取路由器IP失敗",
	"tip.log.queryServerState": "已成功下發查詢設備與服務器交互狀態指令",
	"tip.log.server03": "有03數據交互",
	"tip.log.server04": "有04數據交互",
	"tip.log.heartbeat": "有心跳數據交互",
	"tip.log.noInteraction": "沒有數據交互",
	"tip.log.bluetoothCommunication": "已打通藍牙通訊",
	"tip.log.connectWiFi": "連接WiFi",
	"tip.log.getWiFiList": "正在查詢WiFi列表",
	"tip.log.wifiName": "WiFi名字不能為空，請選擇或輸入2.4WiFi",
	"tip.log.wifiPasword": "WiFi不能為空，請輸入密碼",
	"tip.log.wifiPasswordError": "WiFi密碼不能包含特殊字符(ǎǐò•♢∝⌒℃℉ etc.)",
	"tip.log.masterControlId": "主控ID不能為空，請輸入ID",
	"tip.addDatalogger.noSearchDevice": "無法查詢到設備，請確保設備藍牙已開啟",
	"tip.addDatalogger.searchAroundBluetooth": "周圍可配網藍牙",
	"tip.addDatalogger.scan": "掃描二維碼或在二維碼下方手動輸入數據記錄儀序列號。",
	"tip.addDatalogger.connectBluetoothFail": "藍牙連接失敗，請掃描二維碼或在二維碼下方手動輸入採集器序列號後再次連接。",
	"tip.connectWifi.tip1": "配置設備加入網絡",
	"tip.connectWifi.tip": "請選擇2.4G WiFi",
	"tip.connectWifi.devicePower": "設備功率",
	"tip.connectWifi.enterSSID": "請輸入路由器賬號",
	"tip.connectWifi.enterPassword": "請輸入路由器密碼",
	"tip.connectWifi.masterId": "請輸入主控Id",
	"tip.connectWifi.commandSetFail": "命令設置失敗，請重新連接採集器",
	"tip.configurationState.connecting": "連接中",
	"tip.configurationState.connectFail": "連接失敗",
	"tip.configurationState.connectSuccess": "連接成功",
	"tip.configurationState.wait": "請稍等",
	"tip.configurationState.addDeviceSuccess": "添加設備成功",
	"tip.home.today": "日發電量",
	"tip.home.month": "月發電量",
	"tip.home.year": "年發電量",
	"tip.home.total": "總發電量",
	"tip.home.homePower": "家庭總負載",
	"tip.home.socketPower": "插座負載",
	"tip.home.off-gridPower": "離網負載",
	"tip.home.acPower": "市電功率",
	"tip.home.on-gridPower": "並網有功功率",
	"tip.home.others": "其它",
	"tip.home.latestVersion": "已是最新版本",
	"tip.home.frontEndLoad": "前端負載",
	"tip.home.backEndLoad": "離網負載",
	"tip.energy.choiceDate": "當前的數據只到",
	"tip.energy.explain": "說明",
	"tip.energy.tip1.load": "負載設備所消耗的能源",
	"tip.energy.tip1.solar": "將太陽能轉化為電能，用於電池充電或負載供電的能源",
	"tip.energy.tip1.grid": "累計給電網出售的能源",
	"tip.energy.tip1.battery": "累計給電池充電的電能能源",
	"tip.energy.tip2": "=光伏能源*電價",
	"tip.energy.tip3.title": "社會貢獻計算標準",
	"tip.energy.tip3.title2": "1kWh等於:",
	"tip.energy.tip3.Co2": "減少二氧化碳排放量：",
	"tip.energy.tip3.coal": "節約使用標准煤：",
	"tip.energy.tip3.deforestation": "保護樹木：",
	"tip.plant.comprehensive": "綜合排序",
	"tip.plant.totalEnergyMax": "總電量最高",
	"tip.plant.totalEnergyMin": "總電量最低",
	"tip.plant.realTimePower": "實時功率",
	"tip.plant.pvcapacityMax": "pv容量最高",
	"tip.plant.pvcapacityMin": "pv容量最低",
	"tip.plant.installationDateMax": "裝機日期最遠",
	"tip.plant.installationDateMin": "裝機日期最近",
	"tip.plant.paramChoice": "參數選擇",
	"tip.plant.filter": "篩選",
	"tip.plant.addVisitor": "添加訪客",
	"tip.plant.tip": "提示",
	"tip.plant.visitorTip": "只能分享給已註冊的用戶",
	"tip.plant.name": "名字",
	"tip.plant.permission": "權限",
	"tip.plant.read-write": "讀寫",
	"tip.plant.onlyread": "只讀",
	"tip.plant.visitor": "訪客",
	"tip.plant.unfollow": "你確定要取消對此電站的關注？",
	"tip.device.power": "功率",
	"tip.device.type": "類型",
	"tip.device.updateTime": "更新時間",
	"tip.device.powerOnTime": "上電時間",
	"tip.device.todayEnergy": "今日電量",
	"tip.device.signal": "信號強度",
	"tip.delDevice": "你確定要刪除這個{device}嗎?",
	"tip.currentNoDevice": "當前沒有設備",
	"tip.currentNoDatalog": "當前沒有採集器",
	"tip.messageInfo.storage": "儲能",
	"tip.messageInfo.inverter": "逆變器",
	"tip.messageInfo.microInverter": "微逆",
	"tip.ops.setDomainName": "你確定要設置這個域名嗎？",
	"tip.ops.restartDatalogger": "你確定要重啟採集器嗎？",
	"tip.opsLog.addUser": "添加終端用戶",
	"tip.opsLog.bindSuccess": "綁定成功",
	"tip.opsLog.selectDate": "選擇日期",
	"tip.opsLog.start": "開始",
	"tip.opsLog.end": "結束",
	"tip.opsLog.upgrade": "升級",
	"tip.opsLog.operation": "操作",
	"tip.opsLog.communication": "通訊",
	"tip.opsLog.type": "類型",
	"tip.opsLog.content": "內容",
	"tip.opsLog.control": "控制器",
	"tip.opsLog.command": "命令類型",
	"tip.opsLog.reset": "重置",
	"tip.opsLog.serverTime": "服務器時間",
	"tip.opsLog.inverter": "間隔",
	"tip.opsLog.bindAgent": "綁定經銷商",
	"tip.opsLog.deleteDeviceSN": "請確認是否刪除？",
	"tip.opsLog.recordLog": "需要記錄日誌的設備",
	"tip.userLocation": "用戶所在地",
	"tip.setting.productModelNumberRelevancyOn-gridPower": "併網有功功率不能大於所選產品型號最大功率",
	"productEquipment.productModelNumber": "產品型號",
	"productEquipment.warnMessage": "警告消息",
	"productEquipment.customInstruction": "自定義指令",
	"productEquipment.firmwareUpdate": "固件升級",
	"productEquipment.historicalData": "歷史數據",
	"productEquipment.linkageInformation": "聯繫信息",
	"systemAuthority.systemSettings": "系統設置",
	"systemAuthority.authorityManagement": "權限管理",
	"systemAuthority.accountManagement": "角色管理",
	"systemAuthority.Disabled": "禁用",
	"systemAuthority.enable": "啓用",
	"org.ChangeSupplier": "更改供應商",
	"weather.clearSky": "晴天",
	"weather.fewClouds": "少雲",
	"weather.scatteredClouds": "散佈雲",
	"weather.brokenClouds": "碎雲",
	"weather.overcastClouds": "陰天",
	"weather.lightRain": "小雨",
	"weather.moderateRain": "中雨",
	"weather.heavyRain": "大雨",
	"weather.thunderstormWithLightRain": "小雨伴雷暴",
	"weather.thunderstormWithRain": "降雨伴雷暴",
	"weather.thunderstormWithHeavyRain": "大雨伴雷暴",
	"weather.lightSnow": "小雪",
	"weather.snow": "下雪",
	"weather.heavySnow": "大雪",
	"weather.sleet": "雨夾雪",
	"weather.showerRain": "陣雨",
	"weather.lightShowerRain": "輕微陣雨",
	"weather.heavyShowerRain": "強烈陣雨",
	"weather.mist": "薄霧",
	"weather.smoke": "煙霧",
	"weather.haze": "霾",
	"weather.dust": "塵土飛揚",
	"weather.fog": "霧",
	"weather.sand": "沙塵",
	"weather.ash": "火山灰",
	"weather.squall": "突風",
	"weather.tornado": "龍捲風",
	"register.contactAdminForCode": "請聯繫公司管理員獲取公司註冊碼",
	"register.provideCompanyInfoBelow": "請在下面提供公司信息",
	"register.validation.enterContactName": "請輸入聯繫人姓名",
}